import { render } from "./ShowAllPackage.vue?vue&type=template&id=4cbd520c&scoped=true"
import script from "./ShowAllPackage.vue?vue&type=script&lang=js"
export * from "./ShowAllPackage.vue?vue&type=script&lang=js"

import "./ShowAllPackage.vue?vue&type=style&index=0&id=4cbd520c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbd520c"]])

export default __exports__